import { StyleSheet } from 'react-native';
import SizeUtil from '../../Utils/SizeUtil';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

export default () => {
    return StyleSheet.create({
        benefitBg: {
            height: SizeUtil.getSize(106)
        },
        container: {
            padding: SizeUtil.getSize(16),
            paddingLeft: SizeUtil.getSize(10),
            paddingRight: SizeUtil.getSize(10),
            borderRadius: SizeUtil.getSize(4),
            position: 'relative',
        },
        activityContainer: {
            justifyContent: 'center',
            paddingHorizontal: 12,
            paddingTop: 13
        },
        newChatContainer:{
            paddingTop:3,
            justifyContent: 'center',
            alignItems: 'center'
        },
        backgroundImage: {
            width: SizeUtil.getSize(121),
            height: SizeUtil.getSize(45),
            position: 'absolute',
            right: 0,
            top: 0
        },
        flightContainer: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingHorizontal: SizeUtil.getSize(20)
        },
        flightContainerDesc: {
            fontSize: SizeUtil.getSize(16),
            color: '#f0f'
        },
        flightContainerPrice: {
            fontSize: SizeUtil.getSize(16),
            color: '#ff0'
        },
        tip: {
            paddingLeft: SizeUtil.getSize(20),
            position: 'relative'
        },
        tipIcon: {
            width: SizeUtil.getSize(15),
            height: SizeUtil.getSize(15),
            position: 'absolute',
            top: SizeUtil.getSize(3),
        },
        tipText: {
            color: '#00AE73',
            fontWeight: 'bold',
            fontSize: SizeUtil.getSize(14),
            lineHeight: SizeUtil.getSize(20),
        },
        contentContainer: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: SizeUtil.getSize(16)
        },
        title: {
            fontSize: SizeUtil.getSize(16),
            color: baseColor.text1,
            fontWeight: 'bold',
            lineHeight: SizeUtil.getSize(22)
        },
        subTitle: {
            color: '#999',
            fontSize: SizeUtil.getSize(12),
            lineHeight: SizeUtil.getSize(17),
            marginTop: SizeUtil.getSize(4)
        },
        subTitleIcon: {
            width: SizeUtil.getSize(13),
            height: SizeUtil.getSize(13),
            position: 'absolute',
            top: SizeUtil.getSize(2),
            left: SizeUtil.getSize(2),
            marginRight: SizeUtil.getSize(4)
        },
        bindBtn: {
            width: SizeUtil.getSize(68),
            height: SizeUtil.getSize(28),
            backgroundColor: 'transparent',
            borderWidth: SizeUtil.getSize(1),
            borderColor: '#00CAD8',
            borderRadius: SizeUtil.getSize(14)
        },
        bindBtnTitle: {
            fontSize: SizeUtil.getSize(14),
            lineHeight: SizeUtil.getSize(26),
            textAlign: 'center',
            color: '#00CAD8'
        },
        vipContainer:{
            width: SizeUtil.getSize(351),
            height: SizeUtil.getSize(80),
            marginTop:SizeUtil.getSize(10),
            marginLeft: SizeUtil.getSize(12),
            marginRight: SizeUtil.getSize(12),
            borderRadius: SizeUtil.getSize(8),
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        vipLeft:{
            flexDirection: 'column',
            paddingTop:SizeUtil.getSize(1),
            paddingLeft:SizeUtil.getSize(16)
        },
        leftCon:{
            flexDirection: 'row',
            alignItems: 'center'
        },
        vipIcon: {
            width: SizeUtil.getSize(21),
            height: SizeUtil.getSize(21)
        },
        vipText:{
            fontSize:SizeUtil.getSize(14),
            fontFamily: 'PingFangSC-Regular',
            fontWeight:'400',
            color:'#333333',
            lineHeight:SizeUtil.getSize(20),
            paddingLeft:SizeUtil.getSize(4),
            paddingRight:SizeUtil.getSize(2)
        },
        levelBox:{
            position:'relative',
            alignItems: 'center'
        },
        levelIcon: {
            width: SizeUtil.getSize(39),
            height: SizeUtil.getSize(15)
        },
        vipNumCon:{
            width: SizeUtil.getSize(19),
            height: SizeUtil.getSize(12),
            alignItems: 'center',
            justifyContent:'center',
            position:'absolute',
            top:SizeUtil.getSize(1),
            right:SizeUtil.getSize(0)
        },
        vipNum:{
            fontSize:SizeUtil.getSize(10),
            fontFamily: '20th_bold',
            color:'#643B18'
        },
        leftText:{
            marginTop:SizeUtil.getSize(8),
            fontSize:SizeUtil.getSize(16),
            fontFamily: 'PingFangSC-Regular',
            fontWeight:'400',
            color:'#333333',
            lineHeight:SizeUtil.getSize(22)
        },
        vipRight:{
            flexDirection: 'column',
            alignItems: 'flex-end',
            justifyContent:'center'
        },
        levelLine:{
            flexDirection: 'row',
            position:'absolute',
            top:SizeUtil.getSize(6)
        },
        mline:{
            flexDirection: 'row',
            height: SizeUtil.getSize(3)
        },
        lline:{
            width: SizeUtil.getSize(38),
            height: SizeUtil.getSize(3)
        },
        mline0:{
            width: SizeUtil.getSize(46),
            height: SizeUtil.getSize(3),
            borderTopRightRadius:SizeUtil.getSize(3),
            borderBottomRightRadius:SizeUtil.getSize(3),
            backgroundColor:'#FFBB73'
        },
        mlinel:{
            width: SizeUtil.getSize(5),
            height: SizeUtil.getSize(3),
            marginRight:SizeUtil.getSize(2),
            borderTopRightRadius:SizeUtil.getSize(3),
            borderBottomRightRadius:SizeUtil.getSize(3),
            backgroundColor:'#E0DBCC'
        },
        mliner:{
            width: SizeUtil.getSize(39),
            height: SizeUtil.getSize(3),
            borderTopLeftRadius:SizeUtil.getSize(3),
            borderBottomLeftRadius:SizeUtil.getSize(3),
            backgroundColor:'#E0DBCC'
        },
        mline1:{
            width: SizeUtil.getSize(60),
            height: SizeUtil.getSize(3),
            backgroundColor:'#E0DBCC'
        },
        mline2:{
            width: SizeUtil.getSize(60),
            height: SizeUtil.getSize(3),
            backgroundColor:'#FFBB73'
        },
        mlinem:{
            width: SizeUtil.getSize(3),
            height: SizeUtil.getSize(3),
            borderRadius:SizeUtil.getSize(3),
            marginRight:SizeUtil.getSize(2),
            backgroundColor:'#E0DBCC'
        },
        levelGrow:{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent:'center',
            position:'relative'
        },
        levelRights:{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent:'center',
            marginTop: SizeUtil.getSize(6)
        },
        levelImgBg:{
            width: SizeUtil.getSize(32),
            height: SizeUtil.getSize(32),
            borderRadius:SizeUtil.getSize(16),
            alignItems: 'center',
            justifyContent:'center',
            overflow:'hidden'
        },
        levelImg:{
            width: SizeUtil.getSize(26),
            height: SizeUtil.getSize(26),
            marginTop:SizeUtil.getSize(6)
        },
        lvBox:{
            width: SizeUtil.getSize(41),
            height: SizeUtil.getSize(14),
            backgroundColor:'#FFFFFF',
            alignItems: 'center',
            justifyContent:'center',
            borderRadius: SizeUtil.getSize(7)
        },
        lvText:{
            fontSize:SizeUtil.getSize(11),
            fontFamily: 'PingFangSC-Medium',
            fontWeight:'500',
            color:'#FF8401'
        }
    });
} 
